import React, { useEffect, useState } from 'react';
import BuyerMixCard from './BuyerMixCard';
import DemographicsCard from './DemographicsCard';
import AffinityCard from './AffinityCard';
import client from '../api/client';
import './marketingShared.css';
import './AudienceInsights.css';

const AudienceInsights = ({
  teamId,
  confirmId,
  buyerMix: buyerMixProp,
  purchaseTiming: purchaseTimingProp,
  affinity: affinityProp,
  demographics: demographicsProp,
  venueName,
  sectionNumber,
}) => {
  const hasInjectedData = buyerMixProp !== undefined
    || purchaseTimingProp !== undefined
    || affinityProp !== undefined
    || demographicsProp !== undefined;

  const shouldFetch = !hasInjectedData && Boolean(teamId) && Boolean(confirmId);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(shouldFetch);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!shouldFetch) {
      return undefined;
    }

    const controller = new AbortController();
    setLoading(true);
    setError(null);

    client
      .get(`/teams/${teamId}/confirms/${confirmId}/marketing_insights/audience`, {
        signal: controller.signal,
      })
      .then((response) => setData(response.data))
      .catch((err) => {
        if (err.name === 'CanceledError' || err.name === 'AbortError') return;
        setError(err);
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [shouldFetch, teamId, confirmId]);

  const buyerMix = hasInjectedData ? buyerMixProp : data?.buyer_mix;
  const purchaseTiming = hasInjectedData ? purchaseTimingProp : data?.purchase_timing;
  const affinity = hasInjectedData ? affinityProp : data?.affinity;
  const demographics = hasInjectedData ? demographicsProp : data?.demographics;

  return (
    <>
      <div className="mi-section-heading">
        <h2>
          {sectionNumber !== undefined && <span className="mi-section-num">{sectionNumber}</span>}
          Audience &amp; buyer insights
        </h2>
      </div>
      {loading && (
        <div className="mi-audience-loading" role="status" aria-live="polite">
          Loading audience insights…
        </div>
      )}
      {error && !loading && (
        <div className="mi-audience-error" role="alert">
          Couldn't load audience insights. Refresh to try again.
        </div>
      )}
      {!loading && !error && (
        <div className="mi-audience-grid">
          <BuyerMixCard data={buyerMix} venueName={venueName} />
          <DemographicsCard
            purchaseTiming={purchaseTiming}
            uniqueBuyers={buyerMix?.unique_buyers}
            demographics={demographics}
          />
          <AffinityCard data={affinity} />
        </div>
      )}
    </>
  );
};

export default AudienceInsights;
